import React from 'react';
import ReactDOM from 'react-dom/client';
import './src/index.css';
import App from './src/App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Build output contains browser DOM snapshots, not React server-rendered markup.
// Mount consistently to avoid hydration mismatches from lazy routes and browser state.
ReactDOM.createRoot(rootElement).render(app);
